// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"bf5f0852","64":"bf5f0852","75":"bf5f0852","399":"bf5f0852","542":"43e54d70","651":"bf5f0852","833":"bf5f0852","981":"bf5f0852"}[chunkId] + ".chunk.css";
};